import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { EsignTemplatesFieldMappingRequestDto } from 'src/app/shared/vive-api/vive-api-models';

import { BaseModel } from './base-model';
import { Company } from './company';
import { ESignProvider } from './esign-provider';
import { File as ViveFile } from './file';

export class ESignTemplate extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static FileProperties: (
    | {
        property: keyof ESignTemplate;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ESignTemplate;
        type: 'alias';
      }
    | {
        property: keyof ESignTemplate;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ESignProviderId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'TemplateId', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'ESignProvider', model: 'ESignProvider', type: 'association' },
    { property: 'TemplateFile', model: 'File', type: 'association' }
  ];

  static {
    ESignTemplate.FileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ESignTemplate.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ESignTemplate.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ESignTemplate.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(FileObject: Partial<ESignTemplate>) {
    super();

    ESignTemplate.FileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = FileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ESignProviderId?: number;
  CompanyId?: number;
  TemplateId?: string;
  templateType?: 'Vendor Agreement' | 'W9' | 'Vendor Agreement & W9';
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  ESignProvider?: ESignProvider;
  TemplateFile?: ViveFile;

  /**
   * The template's field mapping, sent only on a save that changed it.
   *
   * Write-only on this model: the upsert accepts it, and reads come back
   * without it — the mapping is fetched separately through the AcroForm routes,
   * which report it beside the fields actually in the PDF. Omitted entirely
   * means "leave the mapping alone"; an empty array clears it.
   */
  fields?: EsignTemplatesFieldMappingRequestDto[];
}
